/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
//import VuexPersist from 'vuex-persist'; // disable persistence

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

import moduleAuth from './modules/auth';
import moduleBuyer from './modules/buyer';
import moduleUser from './modules/user';
import moduleForm from './modules/form';
import moduleOrganization from './modules/organization';
import moduleProduct from './modules/product';
import moduleOrder from './modules/order';
import moduleTeam from './modules/team';
import moduleInventory from './modules/inventory';
import moduleFulfillment from './modules/fulfillment';
import moduleCard from './modules/card';
import moduleSubscription from './modules/subscription';
import moduleShippingRate from './modules/ShippingRate';
import moduleEasyparcel from './modules/easyparcel';


//const vuexLocalStorage = new VuexPersist({
  //key: 'vuex', // The key to store the state on in the storage provider.
  //storage: window.localStorage, // or window.sessionStorage or localForage
  //// Function that passes the state and returns the state with only the objects you want to store.
  //// reducer: state => state,
  //// Function that passes a mutation and lets you decide if it should update the state in localStorage.
  //// filter: mutation => (true)
//})

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    user: moduleUser,
    form: moduleForm,
    team: moduleTeam,
    organization: moduleOrganization,
    product: moduleProduct,
    order: moduleOrder,
    inventory: moduleInventory,
    fulfillment: moduleFulfillment,
    card: moduleCard,
    subscription: moduleSubscription,
    shipping_rate: moduleShippingRate,
    easyparcel: moduleEasyparcel,
    buyer: moduleBuyer,
  },
  strict: process.env.NODE_ENV !== 'production',
  //plugins: [vuexLocalStorage.plugin],
})
